import React, {createContext, useState, useEffect, useContext} from 'react'
import authorize from './helpers/authorize'
import { getCodeFromLocation } from './helpers/getCodeFromLocation'
import { fetchToken } from './helpers/fetchToken'

import { removeCodeFromLocation } from './helpers/removeCodeFromLocation'
import { getVerifierState } from './helpers/getVerifierState'
import { removeStateFromStorage } from './helpers/removeStateFromStorage'
import { Image } from 'react-bootstrap';
import CClogo from '../assets/CClogo.png';
import { Sentry } from 'react-activity';
import 'react-activity/dist/react-activity.css';
import {AES, enc}from 'crypto-js';
import Cookies from 'cookies-js';




export default ({
  clientId,
  clientSecret,
  provider,
  scopes = [],
  tokenEndpoint = `${provider}/token`,
  storage = sessionStorage,
  fetch = window.fetch,
  busyIndicator = <><div style={{ height: "100%",width: "100%",position:'absolute', overflow:'hidden'}}><div style={{
    //background: "#CCCCCC",
    display: 'flex',
    height: "100%",
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection:'column'}}><Image style={{alignSelf:'center',
    width: 150,
    height: 150}} src={CClogo} /><Sentry color="red"/></div></div></>
}) => {

  const context = createContext({})
  const {Provider} = context

  class Authenticated extends React.Component {
    static contextType = context
    componentDidMount() {
      const { ensureAuthenticated } = this.context
      ensureAuthenticated()
        
    }
    
    render() {
      const { token } = this.context
      const { children } = this.props
      //console.log(this.context,"===========>>>>>>>>CONTEXT ToKeN")
      //return children
      //const token= sessionStorage.getItem("isAuthenticated")
      //const getRefreshToken = JSON.parse(token)
     // console.log(getRefreshToken,"<<<<<<<<>>>>>>>")
      if (!Cookies.get('msAL_admin_dev')) {
        return busyIndicator
      } else {
        return children
      }
    }
  }

  const useToken = () => {
    const { token } = useContext(context)
    if (!Cookies.get('msAL_admin_dev')) {
      console.warn(`Trying to useToken() while not being authenticated.\nMake sure to useToken() only inside of an <Authenticated /> component.`)
    }
    return token
  }

  return {
    AuthContext: ({children}) => {
      const [token, setToken] = useState(null)
      
      // if we have no token, but code and verifier are present,
      // then we try to swap code for token
      useEffect(() => {
console.log(getCodeFromLocation({ location: window.location }))
console.log(getVerifierState({ clientId, storage }))
        ///////////
        if (!Cookies.get('msAL_admin_dev')) {
          const code = getCodeFromLocation({ location: window.location })
          const state = getVerifierState({ clientId, storage })
          if (code && state) {
            console.log("BLA")
            fetchToken({
              clientId, clientSecret, tokenEndpoint, code, state, fetch
            })
            .then(setToken)
            .then(() => {
              removeCodeFromLocation()
              removeStateFromStorage({ clientId, storage })  
              console.log("BLAAA")

              //Data Decryption
              
                const refreshToken =  sessionStorage.getItem("isAuthenticated")
               const decrypted = AES.decrypt(refreshToken, 'itsEncrypted');
             const decryptedObject = decrypted.toString(enc.Utf8);
               const getRefreshToken = JSON.parse(decryptedObject)
               sessionStorage.setItem("Decrypted Token",JSON.stringify(getRefreshToken))
             
             
            })
            .catch(e => {
              console.error(e)
              //alert(`Error fetching auth token: ${e.message}`)
            })
          }
        }
      }, [token])

      const ensureAuthenticated = () => {
        const code = getCodeFromLocation({ location: window.location })
        if (!Cookies.get('msAL_admin_dev') && !code) {
          authorize({provider, clientId, scopes})
        }
      }

      return (
        <Provider value={{token, ensureAuthenticated}}>
          {children}
        </Provider>
      )
    },
    Authenticated,
    useToken
  }
}
